export const tendersOnboarding = {
    nameKey: 'tenders.product.name',
    verticals: [{ id: 'pv', nameKey: 'tenders.verticals.pv.label' }],
} as const;
